// 3rd Party
import { library, dom } from '@fortawesome/fontawesome-svg-core';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons/faChevronLeft';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons/faChevronRight';
import { faStar as faStarSolid } from '@fortawesome/free-solid-svg-icons/faStar';
import { faStarHalfAlt } from '@fortawesome/free-solid-svg-icons/faStarHalfAlt';
import { faStar } from '@fortawesome/free-regular-svg-icons/faStar';
library.add(
    faChevronLeft,
    faChevronRight,
    faStar,
    faStarHalfAlt,
    faStarSolid
);
dom.watch();